import styled from 'styled-components';

export const SideTextContent = styled.div`
  color: ${({ theme }) => theme.colors.grayMain};
`;

export const DocumentContainer = styled.div`
  display: flex;
  align-items: center;
  height: 78px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.grayLight};
  padding: 0px 1rem;
`;

export const DocumentContent = styled.div`
  display: flex;
  width: 100%;
`;

export const DocumentTextContainer = styled.div`
  width: 100%;
`;

export const DocumentNameRemove = styled.div`
  display: flex;
  justify-content: space-between;
`;
